// extracted by mini-css-extract-plugin
module.exports = {"root":"statistics_root__3pzTU","content":"statistics_content__1zK53","head":"statistics_head__3Nu9L"};